import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LoginForm from './components/LoginForm';

const AuthPage = () => {
  const { isAuth } = useSelector((store) => store.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth) {
      navigate('/kitchen/dashboard');
    } 
  }, [isAuth]);

  return (
    <LoginForm/>
  );
};

export default AuthPage;
